import { subscribeWS, unsubscribeWS } from 'modules/websocket/WSManager';
import { onUpdateEstimatedTime } from 'modules/queues/Schedule/actions/appointmentsEstimatesTimeToBeServed';
import { WS_ESTIMATED_TIME_UPDATE as WS_ESTIMATED_TIME_UPDATE_SERVICE } from 'modules/websocket/services/wsEstimatedTimeUpdates';

const WS_ESTIMATED_TIME_UPDATE = 'WS_ESTIMATED_TIME_UPDATE';

export const startObserveEstimatedTimeUpdates = () => (dispatch, getState) => {
  const appointmentIds = getState().queues.schedule.appointments.byId;

  return subscribeWS(
    WS_ESTIMATED_TIME_UPDATE_SERVICE,
    { appointmentIds },
    (...args) => dispatch(onUpdateEstimatedTime(...args)),
    WS_ESTIMATED_TIME_UPDATE,
  );
};

export const stopObserveEstimatedTimeUpdates = () => unsubscribeWS(WS_ESTIMATED_TIME_UPDATE);
